<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    @hidden="onHidden"
  >

    <b-card class="mb-0">
      <h5>Editar diagnostico</h5>

      <div v-if="diagnostico">
        <b-row class="d-flex align-items-center my-2">
          <label class="col">
            {{ diagnostico.diagnostico.text }}
          </label>
        </b-row>

        <b-row class="d-flex align-items-center my-2">
          <label class="col-3">Principal: </label>
          <b-form-checkbox
            class="col"
            switch
            v-model="diagnostico.principal"
            :disabled="hiddenSwitchPrincipal"
          />
        </b-row>

        <b-row class="d-flex align-items-center my-2"> 
          <label for="" class="col-3"> Tipo:</label>
          <v-select
            v-model="diagnostico.tipo"
            class="col p-0"
            :options="tipoDiagnosticoOpts"
            label="text"
          />
        </b-row>

        <!-- <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="primary"
            @click="onSave"
          >
            <i class="fas fa-save"/>
            Guardar
          </b-button>
        </div> -->
      </div>
      
      
    </b-card>


  </b-modal>
</template>

<script>


import vSelect from "vue-select";
import { diagnosticosService } from '@/views/atencionMedica/services';

export default {

  name: 'DiagnosticoModalEdit',

  props: {
    value: {
      type: [Number, null],
      default: null
    },

    diagnosticosList:{
      type: Array,
      default: () => []
    }
  },

  components: {
    vSelect
  },

  data() {
    return {
      isVisible: false,
      diagnostico: null,
      tipoDiagnosticoOpts: [],
    }
  },


  created() {
    this.loadDataInit();
  },


  methods: {

    async loadDataInit(){
      this.tipoDiagnosticoOpts = await diagnosticosService.getTiposSelect();
    },

    onSave(){
      console.log('onSave');
    },


    onHidden() {
      this.isVisible = false;
      this.$emit('input', null);
    }
  },


  computed: {
    indexItem(){
      return this.value;
    },


    hiddenSwitchPrincipal(){

      const hayUnPrincipal = this.diagnosticosList.some( item => item.principal === true );
      const actualEsPrincipal = this.diagnostico.principal === true;

      const codigoDiagnostico = this.diagnostico?.diagnostico?.codigo
      if(codigoDiagnostico){
        const firstChar = codigoDiagnostico[0];
        if(firstChar === 'R' || firstChar === 'r') return true;
      }

      if(!hayUnPrincipal) return false;
      if(hayUnPrincipal && actualEsPrincipal) return false;

      return true;
    },
  },


  watch: {

    indexItem: {
      handler(newValue){
        this.isVisible = (newValue !== null && newValue !== undefined);

        if(newValue === null ) return;
        this.diagnostico = this.diagnosticosList[newValue];

      },

    },


  }
}
</script>
